(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bundle-offer]').forEach(function (offer) {
      var form = offer.closest('form') || document;
      var tiers = offer.querySelectorAll('[data-bundle-qty]');

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          var qty = parseInt(tier.getAttribute('data-bundle-qty'), 10);
          var input = form.querySelector('input[name="quantity"]');

          if (!input) {
            return;
          }

          tiers.forEach(function (t) {
            t.setAttribute('aria-pressed', t === tier ? 'true' : 'false');
          });

          input.focus();
          input.value = qty;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.blur();
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
      var mode = bar.getAttribute('data-mode');

      if (mode !== 'product') {
        return;
      }

      var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10);
      var unitPrice = parseInt(bar.getAttribute('data-base-cents'), 10);
      var fill = bar.querySelector('[data-free-shipping-fill]');
      var message = bar.querySelector('[data-free-shipping-message]');
      var lockedPrefix = bar.dataset.lockedPrefix || 'Add';
      var lockedSuffix = bar.dataset.lockedSuffix || 'more for free AU shipping';
      var unlockedText = bar.dataset.unlockedText || "You've unlocked free AU shipping!";
      var form = bar.closest('form') || document;
      var quantityInput = form.querySelector('input[name="quantity"]');

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function update() {
        var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        var total = unitPrice * qty;
        var percent = Math.min(100, Math.round((total / threshold) * 100));

        fill.style.setProperty('--free-shipping-percent', percent + '%');

        if (total >= threshold) {
          message.textContent = unlockedText;
        } else {
          message.textContent = lockedPrefix + ' ' + formatMoney(threshold - total) + ' ' + lockedSuffix;
        }
      }

      if (quantityInput) {
        quantityInput.addEventListener('input', update);
        quantityInput.addEventListener('change', update);
      }

      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-bundle-qty]')) {
          setTimeout(update, 0);
        }
      });

      update();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sale-countdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sale-countdown]').forEach(function (root) {
      var endTime = new Date(root.getAttribute('data-end')).getTime();
      var unitsEl = root.querySelector('[data-sale-countdown-units]');
      var headingEl = root.querySelector('[data-sale-countdown-heading]');
      var endedEl = root.querySelector('[data-sale-countdown-ended]');
      var daysEl = root.querySelector('[data-sale-countdown-days]');
      var hoursEl = root.querySelector('[data-sale-countdown-hours]');
      var minutesEl = root.querySelector('[data-sale-countdown-minutes]');
      var secondsEl = root.querySelector('[data-sale-countdown-seconds]');

      if (isNaN(endTime)) {
        return;
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      function tick() {
        var remaining = endTime - Date.now();

        if (remaining <= 0) {
          unitsEl.hidden = true;
          headingEl.hidden = true;
          endedEl.hidden = false;
          clearInterval(interval);
          return;
        }

        var days = Math.floor(remaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((remaining / (1000 * 60)) % 60);
        var seconds = Math.floor((remaining / 1000) % 60);

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      var interval = setInterval(tick, 1000);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
